import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { compose } from '../../../../../../services/utilityFunctions';
import translate from '../../../../../../commonComponents/translate';
import Modal from '../../../../../../commonComponents/modal/Modal';
import ModalHeader from '../../../../../../commonComponents/modal/ModalHeader';

function ConnectorCalendlyModal(props) {
  const { t, onClose, handleRemoveCalendly } = props;
  const [isRemoving, setIsRemoving] = useState(false);

  return (
    <Modal id="connectorCalendlyModal" onClose={onClose}>
      <div
        className="modal-dialog modal-dialog-centered modal-lg"
        role="document"
      >
        <div className="modal-content">
          <ModalHeader
            title={t(
              'profile.connectors.tab.connector.calendly.modalRemoveAuth.title',
            )}
            onClose={onClose}
          />
          <div className="modal-body">
            <span>
              {t(
                'profile.connectors.tab.connector.calendly.modalRemoveAuth.text',
              )}
            </span>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              disabled={isRemoving}
              className={`btn btn-dynamic ${
                isRemoving ? 'm-loader m-loader--right m-loader--light' : ''
              }`}
              onClick={() => {
                setIsRemoving(true);
                handleRemoveCalendly();
              }}
            >
              {t('btn.disable')}
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

ConnectorCalendlyModal.propTypes = {
  t: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  handleRemoveCalendly: PropTypes.func.isRequired,
};
ConnectorCalendlyModal.defaultProps = {};
export default compose(translate)(ConnectorCalendlyModal);
